import { useCallback } from "react"
import { clearOnLogout } from "apolloClient"
import Button from "components/shared/Button"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { useMutation } from "@apollo/client"
import Nav from "components/shared/Nav"
import isEmpty from "lodash/isEmpty"
import { Logout } from "./operations"
import infoIcon from "./assets/info-icon.svg"
import styles from "./SmsScreen.module.scss"

const SmsScreen = ({
  heading,
  description,
  icon,
  iconClassName,
  hideBackButton = true,
  buttons = [],
  disclaimer,
  showLogoutButton = false
}) => {
  const history = useHistory()
  const [logoutUser, { client }] = useMutation(Logout)
  const logout = useCallback(() => {
    clearOnLogout(client)
    logoutUser({
      variables: {
        input: {}
      }
    })
    history.push("/login")
  }, [logoutUser])

  const allButtons = showLogoutButton
    ? [...buttons, { text: "Log Out", outline: true, onClick: logout }]
    : buttons

  const renderButton = (button, index) => {
    const {
      text,
      to,
      onClick,
      external = false,
      primary = false,
      secondary = false,
      outline = false,
      link = false,
      className = "",
      disabled = false
    } = button

    const buttonElement = (
      <Button
        primary={primary}
        secondary={secondary}
        outline={outline}
        link={link}
        onClick={onClick}
        disabled={disabled}
        className={className}
      >
        {text}
      </Button>
    )

    if (to) {
      return external ? (
        <Link key={index} to={to} target="_blank" className={styles.buttonLink}>
          {buttonElement}
        </Link>
      ) : (
        <Link key={index} to={to} className={styles.buttonLink}>
          {buttonElement}
        </Link>
      )
    }

    return (
      <div key={index} className={styles.buttonLink}>
        {buttonElement}
      </div>
    )
  }

  return (
    <>
      <Nav hideLogin hideBackButton={hideBackButton} />
      <div className={styles.container}>
        {icon && (
          <img
            className={iconClassName || styles.iconStyle}
            src={icon}
            alt="sms-screen-icon"
          />
        )}
        {heading && <span className={styles.heading}>{heading}</span>}
        {description && <p className={styles.description}>{description}</p>}
        <div className={styles.buttonsContainer}>
          {!isEmpty(disclaimer) && (
            <div className={styles.disclaimer}>
              <img src={infoIcon} alt="info" />
              <p className={styles.disclaimerText}>{disclaimer}</p>
            </div>
          )}
          {allButtons.map(renderButton)}
        </div>
      </div>
    </>
  )
}

SmsScreen.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.object,
  hideBackButton: PropTypes.bool,
  disclaimer: PropTypes.string,
  showLogoutButton: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      onClick: PropTypes.func,
      external: PropTypes.bool,
      primary: PropTypes.bool,
      secondary: PropTypes.bool,
      className: PropTypes.string,
      disabled: PropTypes.bool
    })
  )
}

export default SmsScreen
